import { getSvgIcon } from '@helpers/icons';
import { clamp } from '@helpers/utils';
import { CheckboxListOption } from '@stories/Components/Misc/Forms/Inputs/CheckboxList/CheckboxList';
import * as React from 'react';
import S from './CommunityFilter.styles';
const CommunityFilter = (props) => {
    const optionsRef = React.useRef([]);
    if (!props.filters.options || props.filters.options.length === 0) {
        return null;
    }
    return (React.createElement(S.Container, null,
        React.createElement(S.Label, { id: "community-filters-label" }, props.translations?.['community.listings.select']),
        React.createElement(S.Options, { role: "group", "aria-labelledby": "community-filters-label" }, props.filters.options.map((option, i) => (React.createElement(CheckboxListOption, { key: `community-filter-${option.value}`, ref: (el) => (optionsRef.current[i] = el), id: `filter`, name: 'community', role: "checkbox", value: option.value, onChange: () => props.filters.onChange?.(option.value), onKeyDown: (event) => {
                const nextIndex = i === props.filters.options.length - 1
                    ? 0
                    : clamp(i + 1, props.filters.options.length - 1);
                const prevIndex = i === 0
                    ? props.filters.options.length - 1
                    : clamp(i - 1, props.filters.options.length - 1);
                switch (event.key) {
                    case 'ArrowRight':
                        event.preventDefault();
                        event.stopPropagation();
                        optionsRef.current[nextIndex]?.focus();
                        break;
                    case 'ArrowLeft':
                        event.preventDefault();
                        event.stopPropagation();
                        optionsRef.current[prevIndex]?.focus();
                        break;
                }
            }, checked: props.filters.value.includes(option.value) },
            getSvgIcon(option.icon),
            option.label))))));
};
export default CommunityFilter;
